export default "__VITE_ASSET__daef1a9c__"